const TASK_VIEW_TYPES = {
  INCOMPLETE_OR_ACTIVE: 'IncompleteOrActive',
  COMPLETE_OR_ARCHIVED: 'COMPLETE_OR_ARCHIVED',
  DUE_DATE: 'DUE_DATE',
  START_DATE: 'START_DATE'
};

export default TASK_VIEW_TYPES;
